// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KEu9","importantInfo":"styles_importantInfo__2qRGk"};